import WrapperComponent from '../components/hoc/Wrapper-component';
import { ScanIncentive } from './scan-incentive/ScanIncentive';
import { ScanHistory } from './scan-history/ScanHistory';
import { LoginEmployee } from './login-employee/LoginEmployee';
import { LogoutEmployee } from './logout/LogoutEmployee';

export default {
  ScanIncentive: WrapperComponent('ScanIncentive')(ScanIncentive),
  ScanHistory: WrapperComponent('ScanHistory')(ScanHistory),
  LoginEmployee: WrapperComponent('LoginEmployee')(LoginEmployee),
  LogoutEmployee: WrapperComponent('LogoutEmployee')(LogoutEmployee),
};
